export default __webpack_public_path__ + "static/media/Horne FL 11.5984acd2.JPEG";